'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseReportController = require('../../reports/baseReportController');

var _baseReportController2 = _interopRequireDefault(_baseReportController);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FailedWebEnquiriesController = function (_BaseReportController) {
  (0, _inherits3.default)(FailedWebEnquiriesController, _BaseReportController);

  function FailedWebEnquiriesController(authService, reportingService, appConfig, enums, loadingService, utilsService, adminService, webEnquiriesService, $ngConfirm, growl) {
    "ngInject";

    (0, _classCallCheck3.default)(this, FailedWebEnquiriesController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FailedWebEnquiriesController.__proto__ || (0, _getPrototypeOf2.default)(FailedWebEnquiriesController)).call(this, reportingService, loadingService, utilsService));

    _this.authService = authService;
    _this.reportingService = reportingService;
    _this.appConfig = appConfig;
    _this.enums = enums;
    _this.loadingService = loadingService;
    _this.utilsService = utilsService;
    _this.adminService = adminService;
    _this.webEnquiriesService = webEnquiriesService;
    _this.$ngConfirm = $ngConfirm;
    _this.growl = growl;

    _this.reportCriteria = {};
    _this.dtPopups = {};
    _this.errMsgs = [];

    _this.panels = {
      reportCriteria: true,
      reportData: true
    };

    _this.locationSelectSettings = {
      displayProp: 'item2',
      idProp: 'item1',
      enableSearch: true,
      scrollableHeight: '500px',
      scrollable: true,
      styleActive: true,
      closeOnBlur: true
    };

    _this.getLocations().then(function (response) {
      _this.getDateRangeList();
      _this.getSourceList();
      _this.reset();
    });

    _this.viewEmailUrl = _this.appConfig.apiServiceBaseUri + 'api/file/getemail/';
    _this.viewApiDataUrl = _this.appConfig.apiServiceBaseUri + 'api/file/getapidata/';
    return _this;
  }

  (0, _createClass3.default)(FailedWebEnquiriesController, [{
    key: 'convertEnumToKeyValueList',
    value: function convertEnumToKeyValueList(enumObj, defaultOption) {
      var objList = [];

      if (defaultOption) {
        objList.push({
          id: null,
          name: 'Please Select'
        });
      }

      for (var prop in enumObj) {
        objList.push({
          id: enumObj[prop],
          name: prop
        });
      }

      return objList;
    }
  }, {
    key: 'getDateRangeList',
    value: function getDateRangeList() {
      this.dateRangeList = this.convertEnumToKeyValueList(this.enums.DATE_RANGE_TYPE);
    }
  }, {
    key: 'getSourceList',
    value: function getSourceList() {
      this.sourceList = [{ id: null, name: 'All' }, { id: 1, name: 'Email' }, { id: 2, name: 'Api' }];
    }
  }, {
    key: 'getLocations',
    value: function getLocations() {
      var _this2 = this;

      var source = this.adminService.getWebEnquiryLocations();

      source.then(function (response) {
        _this2.userLocations = response.data;
      });

      return source;
    }
  }, {
    key: 'showDatePopup',
    value: function showDatePopup(fieldName) {
      this.dtPopups[fieldName] = true;
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.errMsgs = [];

      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
      this.reportCriteria.startDate = new Date();
      this.reportCriteria.endDate = new Date();
      this.reportCriteria.locationIds = [];
      this.reportCriteria.additionalParameter1 = 'All';
      this.reportCriteria.additionalParameter2 = null;
      this.reportCriteria.additionalParameter3 = null;
      this.reportCriteria.additionalParameter4 = 'All';
    }
  }, {
    key: 'validateCriteria',
    value: function validateCriteria() {
      this.errMsgs = [];

      if (!this.reportCriteria.startDate) {
        this.errMsgs.push('Please provide a Start Date');
      }

      if (!this.reportCriteria.endDate) {
        this.errMsgs.push('Please provide an End Date');
      }

      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
        this.errMsgs.push('Start Date can not be greater than End Date');
      }

      return this.errMsgs.length === 0;
    }
  }, {
    key: 'parseCriteria',
    value: function parseCriteria() {
      var parsedCriteria = {};

      this.parseStartAndEndDate(parsedCriteria);

      parsedCriteria.locationIds = this.reportCriteria.locationIds.map(function (l) {
        return l.item1;
      });
      parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;
      parsedCriteria.additionalParameter2 = this.reportCriteria.additionalParameter2;
      parsedCriteria.additionalParameter3 = this.reportCriteria.additionalParameter3;
      parsedCriteria.additionalParameter4 = this.reportCriteria.additionalParameter4;

      return parsedCriteria;
    }
  }, {
    key: 'viewWebEnquiries',
    value: function viewWebEnquiries() {
      var ctrl = this;

      if (!this.validateCriteria()) {
        return;
      }

      ctrl.loadingService.showLoading('webEnquiriesList', 'Loading Web Enquiries ...');

      ctrl.webEnquiriesService.listWebEnquiries(this.parseCriteria()).then(function (response) {
        ctrl.webEnquiries = response.data;
      }).catch(function (err) {}).finally(function () {
        ctrl.loadingService.hideLoading('webEnquiriesList');
      });
    }
  }, {
    key: 'reprocessConfirm',
    value: function reprocessConfirm(webEnquiryId) {
      var _this3 = this;

      this.$ngConfirm({
        title: false,
        content: 'Are you sure you want to mark this enquiry for reprocessing ?',
        typeAnimation: false,
        columnClass: 'm',
        buttons: {
          yes: {
            text: 'Yes',
            btnClass: 'btn-primary',
            action: function action() {
              _this3.reprocess(webEnquiryId);
            }
          },
          no: {
            text: 'Not Sure',
            btnClass: 'btn-default'
          }
        }
      });
    }
  }, {
    key: 'reprocess',
    value: function reprocess(webEnquiryId) {
      var _this4 = this;

      var ctrl = this;

      ctrl.loadingService.showLoading('failedWebEnquiriesList', 'Updating Enquiries');

      ctrl.webEnquiriesService.reprocess(webEnquiryId).then(function (response) {
        _this4.growl.success('Enquiry marked for reprocessing successfully', { ttl: 5000 });
        _this4.removeEnquiryAndUpdateCount(webEnquiryId);
      }).catch(function (err) {
        _this4.growl.error('An error occurred while reprocessing enquiry', { ttl: 5000 });
      }).finally(function () {
        ctrl.loadingService.hideLoading('failedWebEnquiriesList');
      });
    }
  }, {
    key: 'removeEnquiryAndUpdateCount',
    value: function removeEnquiryAndUpdateCount(webEnquiryId) {
      var webEnquiry = this.webEnquiries.find(function (we) {
        return we.webEnquiryId === webEnquiryId;
      });
      this.webEnquiries = (0, _lodash.without)(this.webEnquiries, webEnquiry);
    }
  }, {
    key: 'viewApiData',
    value: function viewApiData(webEnquiryId) {
      alert(webEnquiryId);
    }
  }]);
  return FailedWebEnquiriesController;
}(_baseReportController2.default);

exports.default = FailedWebEnquiriesController;


// WEBPACK FOOTER //
// ./client/app/components/admin/failedWebEnquiries/failedWebEnquiries.controller.js